import Channel from '../../domain/Channel';
import getChildrenNodes from './getChildrenNodes';

export default (channels: Channel[], activeNode: number, currentNode: number): boolean => {
    const childrenNodes = getChildrenNodes(channels, currentNode);
    const containsActiveNode: boolean = childrenNodes.some((childrenNode: Channel) => {
        if (childrenNode.id === activeNode) {
            return true;
        } else {
            const grandChildrenNodes = getChildrenNodes(channels, childrenNode.id);
            if (grandChildrenNodes.find((grandChildren: Channel) => grandChildren.id === activeNode)) {
                return true;
            }
            return false;
        }
    });
    return activeNode === currentNode || containsActiveNode;
};



// WEBPACK FOOTER //
// ./src/view/channels/containsActiveNode.ts